import type { StoryRow } from '@/api/stories'
import { Badge } from '@/components/ui/badge'
import { topicLabel } from './topics'

export function TopicBadge({ story }: { story: Pick<StoryRow, 'topic' | 'learning_subject'> }) {
  const label = topicLabel(story.topic, story.learning_subject)
  return label ? <Badge className="max-w-full whitespace-normal">{label}</Badge> : null
}
